import { Hourglass } from 'lucide-react';

export const EsignHolds = ({ holds, testId }) => (holds?.length ? (
  <div className="rounded-md border border-sky-200 bg-sky-50 p-3 text-sm text-sky-900" data-testid={testId}>
    <p className="mb-1 flex items-center gap-2 font-medium"><Hourglass className="h-4 w-4" />Before onboarding is completed</p>
    <ul className="list-disc pl-6">{holds.map((h) => <li key={h}>{h}</li>)}</ul>
  </div>
) : null);
